import script from "./BasePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasePage.vue?vue&type=script&setup=true&lang=ts"

import "./BasePage.vue?vue&type=style&index=0&id=d9895664&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9895664"]])

export default __exports__